import { makeServerPost, makeServerRequest } from './util';

export const loginSuccess = (data) => {

    return {
        type: "LOGIN_SUCCESS",
        payload: data
    };
};

export const loginFailure = (error) => {

    return {
        type: "LOGIN_FAILURE",
        payload: error
    };
};

export const login = (username, password) => {

    const data = new FormData();
    data.append('username', username);
    data.append('password', password);

    return (dispatch) => {
        dispatch({type: "LOGIN"});

        return makeServerPost("login", data).then(
            response => dispatch(loginSuccess(response.data))
        ).catch(
            error => dispatch(loginFailure(error))
        );
    };
};

export const logout = () => {

    makeServerRequest("logout");

    return {
        type: "LOGOUT"
    };
};

export const forgotPasswordSuccess = (data) => {

    return {
        type: "FORGOT_PASSWORD_SUCCESS",
        payload: data
    };
};

export const forgotPasswordFailure = (error) => {

    return {
        type: "FORGOT_PASSWORD_FAILURE",
        payload: error
    };
};

export const forgotPassword = (email) => {

    const data = {
        email
    };

    return (dispatch) => {
        dispatch({type: "FORGOT_PASSWORD"});

        return makeServerPost("forgot", data).then(
            response => dispatch(forgotPasswordSuccess(response.data))
        ).catch(
            error => dispatch(forgotPasswordFailure(error))
        );
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/login.js